import { Link, NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-id="app-footer" className="mt-12 border-t bg-white">
      <div className="mx-auto max-w-6xl px-6 py-10">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand / about */}
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-black text-white text-xs font-bold">f9</span>
              <span className="font-semibold">free1099calc</span>
            </div>
            <p className="mt-3 text-sm text-slate-600">
              Free tools for 1099 workers, freelancers, and small businesses — taxes, retirement, inflation, and job trends.
            </p>
          </div>

          {/* Calculators */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900">Calculators</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/" className="text-slate-700 hover:underline">Tax Calculator</Link></li>
              <li><Link to="/retirement" className="text-slate-700 hover:underline">Retirement Calculator</Link></li>
              <li><Link to="/calculators/inflation" className="text-slate-700 hover:underline">Inflation Calculator</Link></li>
            </ul>
          </div>

          {/* Learn */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900">Learn</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/blog" className="text-slate-700 hover:underline">Blog</Link></li>
              <li><Link to="/blog/external" className="text-slate-700 hover:underline">External Resources</Link></li>
              <li><Link to="/trends" className="text-slate-700 hover:underline">Job Trends</Link></li>
              <li><Link to="/faq" className="text-slate-700 hover:underline">FAQ</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-slate-900">Company</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/about" className="text-slate-700 hover:underline">About</Link></li>
              <li><Link to="/contact" className="text-slate-700 hover:underline">Contact</Link></li>
              <li><Link to="/privacy" className="text-slate-700 hover:underline">Privacy</Link></li>
              <li><Link to="/terms" className="text-slate-700 hover:underline">Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t pt-6 text-xs text-slate-500 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} free1099calc. Educational use only — not tax or legal advice.</span>
          <nav className="flex flex-wrap items-center gap-4">
            <NavLink to="/" end className="hover:text-black">Tax Calculator</NavLink>
            <NavLink to="/retirement" className="hover:text-black">Retirement</NavLink>
            <NavLink to="/calculators/inflation" className="hover:text-black">Inflation</NavLink>
            <NavLink to="/blog" className="hover:text-black">Blog</NavLink>
            <NavLink to="/blog/external" className="hover:text-black">External</NavLink>
            <NavLink to="/trends" className="hover:text-black">Job Trends</NavLink>
            <NavLink to="/faq" className="hover:text-black">FAQ</NavLink>
            <NavLink to="/contact" className="hover:text-black">Contact</NavLink>
          </nav>
        </div>
      </div>
    </footer>
  );
}
